export const getMessageLinkPreviews = (message: any): any[] => {
  if (Array.isArray(message?.linkPreviews)) return message.linkPreviews.filter(Boolean);
  return message?.linkPreview ? [message.linkPreview] : [];
};

export const mergeMessageLinkPreview = (message: any, preview: any, previewIndex: any): any => {
  if (!message || !preview) return message;
  const current = Array.isArray(message.linkPreviews)
    ? [...message.linkPreviews]
    : (message.linkPreview ? [message.linkPreview] : []);
  const requestedIndex = Number(previewIndex);
  const matchingIndex = current.findIndex((item: any) => item?.url && item.url === preview.url);
  const targetIndex = Number.isInteger(requestedIndex) && requestedIndex >= 0
    ? requestedIndex
    : (matchingIndex >= 0 ? matchingIndex : current.length);
  current[targetIndex] = preview;
  return {
    ...message,
    linkPreviews: current,
    linkPreview: current[0] || message.linkPreview || null,
  };
};
